import React, { FC } from 'react'
import { Datagrid, Filter, FilterProps, List, ListProps, NumberField, SearchInput, TextField } from 'react-admin'
import { Helmet } from 'react-helmet'
import { WEB_APP_TITLE } from 'src/constants'
import RouteBreadcrumbs from '../../components/RouteBreadcrumbs'

const ShipmentTypeFilter: FC<Omit<FilterProps, 'children'>> = (props) => (
  <Filter {...props}>
    <SearchInput source="name,code" alwaysOn />
  </Filter>
)

const ShipmentTypeList: FC<ListProps> = (props) => {
  return (
    <>
      <Helmet title={`${WEB_APP_TITLE} - Shipment types`} />
      <RouteBreadcrumbs {...props} />
      <List
        {...props}
        perPage={25}
        sort={{ field: 'code', order: 'ASC' }}
        filters={<ShipmentTypeFilter />}
        bulkActionButtons={false}
      >
        <Datagrid rowClick="edit">
          <TextField source="name" />
          <TextField source="code" />
          <TextField source="container_size" />
          <TextField source="container_type" />
          <NumberField source="performance_count" />
        </Datagrid>
      </List>
    </>
  )
}

export default ShipmentTypeList
